import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const blogPosts = Object.freeze([
  {
    slug: "quand-accompagnant-soublie",
    title: "Quand l'accompagnant s'oublie : les signaux à ne pas ignorer",
    description: "Tu accompagnes, tu soutiens, tu contiens. Mais toi ? Qui te contient, qui te soutient ? Il y a des signes qu'on apprend à ignorer, parce qu'on pense que « ça va passer » ou que « c'est normal quand on aide les autres ».",
    image: "/lovable-uploads/18a5b1d8-f6d9-4747-b858-04980a911e10.png"
  },
  {
    slug: "se-realigner-respirations",
    title: "Se réaligner quand on donne trop : 3 respirations pour revenir à soi",
    description: "Quand tout va vite. Quand les demandes s'enchaînent. Quand tu sors d'une séance et que tu n'es plus sûr·e d'être encore en toi… Revenir à soi peut être aussi simple que respirer consciemment.",
    image: "/lovable-uploads/f5da67c6-24fc-4e02-b45e-157af8b967bb.png"
  },
  {
    slug: "hypersensibilite-accompagnant",
    title: "Hypersensibilité et posture d'accompagnant : force ou fragilité ?",
    description: "On t'a peut-être dit un jour : « Tu es trop sensible pour ce métier. » Et si c'était justement l'inverse ? Si ta sensibilité était une clef d'accès ? Un radar précieux ? Une porte d'entrée dans l'invisible ?",
    image: "/lovable-uploads/31cb84bc-6bcf-40d3-8b49-0d35fe631210.png"
  },
  {
    slug: "nettoyer-cabinet-energetiquement",
    title: "Nettoyer son cabinet, oui… mais énergétiquement aussi !",
    description: "Tu ouvres ton cabinet. Tout est propre, accueillant. Mais… Et l'énergie qu'il reste de la veille ? L'émotion dense d'un client ? La tienne, après une journée intense ?",
    image: "/lovable-uploads/f2bccdc0-69cc-47ec-8216-0da0fa70c15a.png"
  },
  {
    slug: "poids-invisible-seances",
    title: "Le poids invisible des séances : comment le déposer sans culpabiliser",
    description: "On sort de certaines séances allégé·e. Et d'autres… laissent une trace. Pas par faute de l'autre. Mais parce qu'on a absorbé plus que nécessaire.",
    image: "/lovable-uploads/bb7aa18c-c18b-4aeb-8ef5-8bf138806d5b.png"
  },
  {
    slug: "energie-apaisement-hypnose",
    title: "✨ L'énergie de l'apaisement : réduire son anxiété grâce à l'hypnose",
    description: "Découvrez comment l'hypnose peut vous aider à transformer votre anxiété en une vibration d'apaisement et de sérénité, grâce à un travail sur le langage intérieur et les suggestions positives.",
    image: "/lovable-uploads/a8fcad95-add9-4793-a25d-05a570f09e0f.png"
  },
  {
    slug: "impact-energetique-objets-anciens",
    title: "🪙 L'impact énergétique des objets anciens et hérités",
    description: "Certains objets anciens ou hérités peuvent porter des charges énergétiques. Découvrez comment repérer et nettoyer ceux qui influencent votre bien-être sans que vous en ayez conscience.",
    image: "/lovable-uploads/5464274f-15d9-4d21-acc2-b25dfb424ec8.png"
  },
  {
    slug: "sommeil-soin-spirituel",
    title: "🌙 Le sommeil : un espace de soin spirituel et énergétique",
    description: "Le sommeil est un moment sacré où se régénèrent le corps, l'esprit et l'âme. Découvrez comment en faire un véritable soin énergétique nocturne.",
    image: "/lovable-uploads/094ee070-a084-494a-a18d-3628f439d401.png"
  },
  {
    slug: "energie-des-mots",
    title: "✨ L'énergie des mots : quand la parole guérit… ou détruit",
    description: "Les mots que nous prononçons influencent notre énergie et notre corps. Découvrez comment utiliser consciemment la puissance vibratoire du langage pour vous élever.",
    image: "/lovable-uploads/d4508c9a-35df-47da-bc66-6a77d701acec.png"
  },
  {
    slug: "protection-charges-emotionnelles",
    title: "💙 Comment se protéger des charges émotionnelles des autres",
    description: "Vous absorbez facilement les émotions des autres ? Apprenez à vous protéger des charges émotionnelles et à préserver votre énergie grâce à des pratiques concrètes et énergétiques.",
    image: "/lovable-uploads/ace7b362-5d95-4fab-87e6-7fa73b9660eb.png"
  },
  {
    slug: "stress-professionnel-hypnose",
    title: "🧠 Gérer le stress professionnel : L'hypnose comme solution efficace",
    description: "Découvrez comment l'hypnose peut vous aider à réduire le stress au travail, améliorer votre concentration et retrouver l'équilibre mental.",
    image: "/lovable-uploads/b71d2aaf-7770-4a76-9405-55f0b7ff978b.png"
  },
  {
    slug: "hypnose-changer-vie",
    title: "✨ Et si l'hypnose pouvait vraiment changer votre vie ?",
    description: "Découvrez comment l'hypnose peut vous aider à vous reconnecter à vos ressources intérieures et à transformer votre vie en profondeur.",
    image: "/lovable-uploads/e0bb6d86-570c-4d8a-b903-5fe55932f807.png"
  },
  {
    slug: "hypnose-anxiete",
    title: "🧘‍♀️ Hypnose et Anxiété : Une Voie Douce Vers l'Apaisement Intérieur",
    description: "Découvrez comment l'hypnose peut vous aider à transformer votre anxiété en sérénité et à retrouver un équilibre émotionnel durable.",
    image: "/lovable-uploads/76089dc5-26bc-4819-a81f-1e930be63189.png"
  },
  {
    slug: "tete-ou-coeur",
    title: "💭 Qui parle ? Ma tête ou mon cœur ? Comment savoir ?",
    description: "Tête ou cœur : comment reconnaître quelle voix vous guide ? Découvrez comment différencier la pensée mentale de la véritable intuition, pour des choix plus alignés avec votre être profond.",
    image: "/lovable-uploads/ce9837bc-806a-4ef3-932f-de9a52b14f17.png"
  },
  {
    slug: "burn-out-corps-stop",
    title: "💔 Burn-out : quand le corps dit stop avant que la tête comprenne",
    description: "Le burn-out est un cri silencieux du corps et du cœur. Découvrez comment reconnaître les signes émotionnels du burn-out et retrouver l'équilibre en écoutant votre corps.",
    image: "/lovable-uploads/da428b30-fb34-4509-bcb9-2d65d570f063.png"
  },
  {
    slug: "perdre-du-poids-hypnose",
    title: "🌱 Perdre du poids : comprendre son corps et faire alliance grâce à l'hypnose",
    description: "Découvrez comment l'hypnose peut aider à se libérer du poids en écoutant son corps, en transformant les émotions inconscientes et en réconciliant corps et esprit.",
    image: "/lovable-uploads/e54ccebe-033d-4a33-8493-0cfb4010625d.png"
  },
  {
    slug: "croyances-limitantes",
    title: "🌱 Croyances limitantes : comprendre, identifier, se libérer",
    description: "Découvrez comment identifier et transformer vos croyances limitantes avec l'aide de l'hypnose pour retrouver votre liberté intérieure et votre plein potentiel.",
    image: "/lovable-uploads/4250d183-1e67-4a35-ab6f-28d4f5dd7744.png"
  },
  {
    slug: "dire-non",
    title: "💬 \"Je ne sais pas dire non\" : quand le besoin de plaire étouffe qui l'on est vraiment",
    description: "Découvrez comment l'hypnose peut vous aider à vous libérer du besoin constant de plaire et à retrouver votre authenticité en apprenant à dire non.",
    image: "/lovable-uploads/25cd1570-f789-48a7-8b1d-1e27db2391d6.png"
  },
  {
    slug: "decalage-famille",
    title: "💬 \"Je me sens en décalage avec ma famille depuis toujours\" : quand on ne se sent pas à sa place là où l'on devrait être",
    description: "Découvrez comment transformer ce sentiment de décalage familial en une opportunité de croissance personnelle, et comment l'hypnose peut vous aider à trouver votre véritable place.",
    image: "/lovable-uploads/3e82e6a5-0b7e-49fa-ac87-4ec7d2f47e86.png"
  },
  {
    slug: "blessure-abandon",
    title: "💔 La blessure d'abandon : quand l'absence laisse une trace sur l'amour de soi et des autres",
    description: "Découvrez comment la blessure d'abandon influence nos relations et notre rapport à nous-mêmes, et comment l'hypnose peut nous aider à nous en libérer.",
    image: "/lovable-uploads/26c5a766-8b91-4088-8d9e-33fbd475923e.png"
  },
  {
    slug: "impact-enfance-adulte",
    title: "🌱 L'impact de l'enfance sur ce que l'on devient adulte : un voyage vers la guérison",
    description: "Découvrez comment les expériences de l'enfance façonnent notre vie d'adulte et comment l'hypnose peut vous aider à guérir des blessures du passé pour avancer sereinement.",
    image: "/lovable-uploads/dce4441a-29e0-456d-b5c4-551edfe827e0.png"
  },
  {
    slug: "peur-de-partir",
    title: "🌍 La peur de partir : comprendre, accepter et surmonter cette angoisse",
    description: "Découvrez comment l'hypnose peut vous aider à surmonter vos peurs liées au départ, au changement et à l'inconnu, pour avancer sereinement vers de nouveaux horizons.",
    image: "/lovable-uploads/63529bdd-1a02-4365-8b21-07c7e3b797d8.png"
  },
  {
    slug: "difficulte-lacher-prise",
    title: "🧘‍♀️ La difficulté de lâcher prise : comment l'hypnose peut vous aider à trouver la paix intérieure",
    description: "Découvrez comment l'hypnose peut vous aider à lâcher prise et à retrouver une paix intérieure durable, en transformant vos peurs et vos croyances limitantes.",
    image: "/lovable-uploads/53341ba7-e96e-4fc5-86c6-14a96b43ec95.png"
  },
  {
    slug: "jai-mal-mais-je-sais-pourquoi",
    title: "J'ai mal, mais je sais pourquoi : et si le corps parlait ?",
    description: "Découvrez comment l'hypnose peut vous aider à comprendre et soulager vos douleurs physiques en écoutant ce que votre corps essaie de vous dire.",
    image: "/lovable-uploads/b853eef3-fbad-4b5c-b446-f0fb8eb292a4.png"
  },
  {
    slug: "trop-penser-hypnose",
    title: "🧠 Trop penser : quand le mental ne s'éteint jamais… et comment l'hypnose peut aider",
    description: "Découvrez comment l'hypnose peut vous aider à apaiser un mental survolté et retrouver la paix intérieure.",
    image: "/lovable-uploads/dff0285b-6ccc-481d-b71e-c3cfe2f370b3.png"
  },
  {
    slug: "phobie-message-inconscient",
    title: "Et si votre phobie n'était pas une faiblesse, mais un message de votre inconscient ?",
    description: "Découvrez comment l'hypnose peut vous aider à comprendre et dépasser vos phobies, en dialoguant doucement avec votre inconscient.",
    image: "/lovable-uploads/059ddb3c-f1d7-44a0-8908-6f30026bd3b3.png"
  },
  {
    slug: "arreter-fumer-hypnose",
    title: "Hypnose pour arrêter de fumer à Étampes : comment ça marche ?",
    description: "Découvrez comment l'hypnose peut vous accompagner dans votre démarche d'arrêt du tabac, pour une transformation en douceur et en profondeur.",
    image: "/lovable-uploads/a8cf3a1f-489d-42fb-a769-9dc60cae2b7a.png"
  },
  {
    slug: "culpabilite-hypnose",
    title: "Tu culpabilises… et tu ne sais pas comment t'en sortir ?",
    description: "Découvrez comment l'hypnose peut vous aider à vous libérer de la culpabilité et retrouver votre légèreté intérieure.",
    image: "/lovable-uploads/7f6dd754-84a0-4c97-81cd-835508f7e61e.png"
  },
  {
    slug: "hypnose-transformation-profonde",
    title: "Qu'est-ce que l'hypnose ? Et pourquoi ça transforme en profondeur ?",
    description: "Découvrez l'hypnose ericksonienne : un voyage vers la transformation intérieure et la reconnexion à soi.",
    image: "/lovable-uploads/1f42cb6c-26e6-4514-a39c-031f5a944a52.png"
  }
]);

const Blog = () => {
  return (
    <div className="min-h-screen bg-background pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <Link to="/">
            <Button variant="ghost" className="mb-4">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Retour à l'accueil
            </Button>
          </Link>
          <h1 className="text-4xl font-bold text-primary mb-4">Blog</h1>
          <p className="text-foreground/80">Découvrez mes derniers articles sur le coaching, l'hypnose, le développement personnel, les soins énergétiques et la spiritualité.</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <Link 
              to={`/blog/${post.slug}`} 
              key={post.slug}
              className="group"
            >
              <article className="rounded-lg overflow-hidden shadow-lg bg-card">
                <div className="relative overflow-hidden">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <h2 className="text-xl font-semibold mb-2 text-foreground group-hover:text-primary transition-colors">
                    {post.title}
                  </h2>
                  <p className="text-foreground/80">{post.description}</p>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
